import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container py-5" }
const _hoisted_2 = { class: "tp-login-register-wrapper d-flex justify-content-center align-items-center" }
const _hoisted_3 = { class: "tp-login-from-box" }
const _hoisted_4 = { class: "tp-login-from-heading text-center" }
const _hoisted_5 = { class: "tp-login-from-title" }
const _hoisted_6 = { class: "text-secondary" }
const _hoisted_7 = {
  key: 0,
  class: "alert alert-danger py-2 mt-3"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-info-circle" }, null, -1 /* HOISTED */)
const _hoisted_9 = { class: "tp-login-input-form" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-12" }
const _hoisted_12 = { class: "tp-login-input p-relative" }
const _hoisted_13 = { for: "login-email" }
const _hoisted_14 = ["placeholder"]
const _hoisted_15 = { class: "col-12" }
const _hoisted_16 = { class: "tp-login-from-btn" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  "aria-hidden": "true"
}
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "mt-3 text-center" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h4", _hoisted_5, _toDisplayString($data.lms_website.__('Forgot password')), 1 /* TEXT */),
            _createElementVNode("p", _hoisted_6, _toDisplayString($data.lms_website.__("Enter the email address you use on Coursera. We'll send you a link to reset your password.")), 1 /* TEXT */)
          ]),
          ($data.login_error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _hoisted_8,
                _createTextVNode(" " + _toDisplayString($data.login_error), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("form", {
            method: "post",
            onSubmit: _cache[1] || (_cache[1] = $event => ($options.onSubmit($event)))
          }, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("label", _hoisted_13, _toDisplayString($data.lms_website.__('Email')), 1 /* TEXT */),
                    _withDirectives(_createElementVNode("input", {
                      type: "email",
                      id: "login-email",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.email) = $event)),
                      placeholder: $data.lms_website.__('Type your email'),
                      required: ""
                    }, null, 8 /* PROPS */, _hoisted_14), [
                      [_vModelText, $data.email]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("button", {
                      type: "submit",
                      class: "tp-btn-inner w-100 text-center",
                      disabled: $data.form_loading
                    }, [
                      ($data.form_loading)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_18))
                        : _createCommentVNode("v-if", true),
                      (!$data.form_loading)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString($data.lms_website.__('Reset Password')), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ], 8 /* PROPS */, _hoisted_17)
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("p", null, [
                      _createTextVNode(_toDisplayString($data.lms_website.__('Back to')) + " ", 1 /* TEXT */),
                      _createVNode(_component_router_link, {
                        to: { name: 'auth.login' },
                        class: "text-primary"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($data.lms_website.__('Login')), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["to"])
                    ])
                  ])
                ])
              ])
            ])
          ], 32 /* NEED_HYDRATION */)
        ])
      ])
    ])
  ]))
}